/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AddAction from './AddAction/index'
import React from 'react'
import Referrals from './Referrals/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Referrals
  viewPath={`${viewPath}/Referrals`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
{children}
</React.Fragment>)
}